module.exports = __webpack_public_path__ + "img/vx.a0943b0b.png";